







import Vue from "vue";
import moment from "moment";
import menu from "@/store/modules/ApplicationModule/data/menu";

// Vue components
import AppPage from "@/components/AppPage.vue";
import UserEventsMainTable from "./UserEventsMainTable.vue";
import UserEventsFilter from "./UserEventsFilter.vue";

// Model
import { FetchUserEventsCommand } from "@/model/communication/userEvents/FetchUserEventsCommand";
import { FetchUserEventsResData } from "@/model/communication/userEvents/FetchUserEventsResData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetVisibleUsersResData } from "@/model/communication/userEvents/GetVisibleUsersResData";
import { GetVisibleUsersCommand } from "@/model/communication/userEvents/GetVisibleUsersCommand";

export default Vue.extend({
    components: {
        AppPage,
        UserEventsMainTable,
        UserEventsFilter,
    },
    data() {
        let startDate = moment().utc().toDate();
        let endDate = moment().utc().toDate();
        startDate.setHours(0);
        startDate.setMinutes(0);
        endDate.setHours(23);
        endDate.setMinutes(59);
        return {
            loading: false,
            paginatedTotalItems: 0,
            reqData: null,
            events: [],
            userEventFilterData: {
                startDate: startDate,
                endDate: endDate,
                eventTypes: [],
                installationNames: [],
                response: [],
                involvedUsernames: [],
                usernames: [],
            },
            visibleUsernames: [],
        };
    },
    computed: {
        menuEntry() {
            return menu.find((m) => m.name == "Tools").children.find((c) => c.name == "UserEvents");
        },
    },
    methods: {
        sendRequestFromFilter(request) {
            if (this.$refs.mainTable) this.$refs.mainTable.backToTheFirst();
            this.reqData.offset = 0;
            this.sendRequest(request);
        },
        async sendRequest(request) {
            try {
                this.loading = true;
                if (
                    request.userEventsStartDate == null ||
                    request.userEventsStartDate == undefined ||
                    request.userEventsEndDate == null ||
                    request.userEventsEndDate == undefined
                ) {
                    request.userEventStartDate = this.userEventFilterData.startDate;
                    request.userEventEndDate = this.userEventFilterData.endDate;
                }
                request.eventTypes = this.userEventFilterData.eventTypes;
                if (request.itemsPerPage) {
                    request.offset = (request.page - 1) * request.itemsPerPage;
                    request.queryLimit = request.itemsPerPage;
                } else {
                    request.offset = this.reqData.offset;
                    request.queryLimit = this.reqData.queryLimit;
                }
                if (request.sortBy) {
                    request.orderBy = request.sortBy;
                    request.orderByDescending = request.sortDesc;
                } else {
                    request.orderBy = this.reqData.orderBy;
                    request.orderByDescending = this.reqData.orderByDescending;
                }

                request.responseTypes = this.userEventFilterData.response;
                request.usernames = this.userEventFilterData.usernames;
                request.involvedUsernames = this.userEventFilterData.involvedUsernames;
                request.installationNames = this.userEventFilterData.installationNames;

                this.reqData = request;

                let response: FetchUserEventsResData = await new FetchUserEventsCommand(request).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.events = response.userEvents;
                    this.paginatedTotalItems = response.totalEventsCount;
                }
            } catch (e) {
                console.log("Something went wrong sending FetchUserEventsCommand request ", e);
            }
            this.loading = false;
        },

        async getVisibileUsers() {
            try {
                let response: GetVisibleUsersResData = await new GetVisibleUsersCommand().execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.visibleUsernames = response.visibleUsers;
                }
            } catch (e) {
                console.log("Something went wrong sending FetchUserEventsCommand request ", e);
            }
            this.loading = false;
        },
    },
    mounted() {
        this.getVisibileUsers();
    },
});
